import { Typography } from '@components/common/Typography';
import styled from 'styled-components';

export const ErrorContainer = styled.div`
  margin-bottom: 32px;
`;

export const ErrorText = styled(Typography)`
  font-family: ${({
    theme: {
      fonts: { archivo },
    },
  }) => archivo};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: ${({
    theme: {
      colors: {
        secondary: { red },
      },
    },
  }) => red};
`;
